import React from 'react';

import FiltersTags from 'ha/components/Filters/FiltersTags';
import { SearchFiltersContext } from 'ha/pages/Search/SearchFiltersContext';
import { RadiusValue, Filters } from 'ha/types/SearchFilters';

interface Props {
  withDateFilter?: boolean;
}

const SearchFiltersTags: React.FC<Props> = ({ withDateFilter }) => {
  const {
    localState,
    onChangeBills,
    onChangeDates,
    onChangeFurniture,
    onChangeGender,
    onChangePrice,
    onChangeRecentlyAdded,
    onChangeRegistration,
    onChangeRooms,
    onChangeRules,
    onChangeSuitableFor,
    onChangeTypes,
    onChangePropertySize,
    onChangeFacilities,
    onChangeAmenities,
    onChangeRadius,
  } = React.useContext(SearchFiltersContext);

  const handleRemove = React.useCallback(
    (filter: keyof Filters, removedValue?: string) => {
      if (filter === 'bills') {
        onChangeBills(localState.bills.filter(value => value !== removedValue));
      }
      if (filter === 'furniture') {
        onChangeFurniture(
          localState.furniture.filter(value => value !== removedValue),
        );
      }
      if (filter === 'gender') {
        onChangeGender(
          localState.gender.filter(value => value !== removedValue),
        );
      }
      if (filter === 'recentlyAdded') {
        onChangeRecentlyAdded(null);
      }
      if (filter === 'registration') {
        onChangeRegistration(
          localState.registration.filter(value => value !== removedValue),
        );
      }
      if (filter === 'rules') {
        onChangeRules(localState.rules.filter(value => value !== removedValue));
      }
      if (filter === 'suitableFor') {
        onChangeSuitableFor(
          localState.suitableFor.filter(value => value !== removedValue),
        );
      }
      if (filter === 'types') {
        onChangeTypes(localState.types.filter(value => value !== removedValue));
      }
      if (filter === 'rooms') {
        onChangeRooms({
          bedroomCount: localState.rooms.bedroomCount.filter(
            value => value !== removedValue,
          ),
        });
      }
      if (filter === 'dates') {
        onChangeDates({ startDate: null, endDate: null });
      }
      if (filter === 'price') {
        onChangePrice({ min: null, max: null });
      }
      if (filter === 'propertySize') {
        onChangePropertySize({});
      }
      if (filter === 'facilities') {
        onChangeFacilities(
          localState.facilities.filter(value => value !== removedValue),
        );
      }
      if (filter === 'amenities') {
        onChangeAmenities(
          localState.amenities.filter(value => value !== removedValue),
        );
      }
      if (filter === 'radius') {
        onChangeRadius(RadiusValue.DEFAULT);
      }
    },
    [
      localState,
      onChangeBills,
      onChangeDates,
      onChangeFurniture,
      onChangeGender,
      onChangePrice,
      onChangeRecentlyAdded,
      onChangeRegistration,
      onChangeRooms,
      onChangeRules,
      onChangeSuitableFor,
      onChangeTypes,
      onChangePropertySize,
      onChangeFacilities,
      onChangeAmenities,
      onChangeRadius,
    ],
  );

  return (
    <FiltersTags
      filters={localState}
      onRemove={handleRemove}
      hideDateFilterTag={!withDateFilter}
    />
  );
};

export default SearchFiltersTags;
